import { Url } from '../shared/Url';
import Post from '../shared/Post';
import PostXls from '../shared/PostXls';
import { cookieData } from '../funciones/ConsultaUser';

export const AsistenciaEstXls = (usuario, seccion, seccion_name, respuesta) => {
    let Content = {
        seccion: seccion,
        usuario: usuario
    }
    PostXls(`${Url}xlsAsistencia`, Content, `Asistencia - [${seccion_name}]`,(resp) => {
        respuesta(resp)
    }); 
}

export const consultUsuarios = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
        }

        Post(`${Url}consultUsuarios`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    })
}

export const BusquedaUsu = (string, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            strings: string
        }

        Post(`${Url}BusquedaUsu`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    })
}


// WEBPACK FOOTER //
// ./src/funciones/ReportesFunction.jsx